import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { PerformanceEvent } from '../../../models/performance-event.model';
import { ProgramOrganizationType } from '../../../models/program-organization.model';
import { Product } from '../../../models/program.model';
import * as Selectors from '../../../store/selectors/pd.selectors';
import { PerformanceChartComponent } from '../performance-chart/performance-chart.component';

@Component({
  selector: 'fdr-past-performance-ui-performance-overview',
  imports: [CommonModule, PerformanceChartComponent],
  templateUrl: './performance-overview.component.html',
  styleUrl: './performance-overview.component.scss',
})
export class PerformanceOverviewComponent {
  private store = inject(Store);
  private readonly viewMode = this.store.selectSignal(Selectors.selectViewMode);
  private readonly products = this.store.selectSignal(Selectors.selectProducts);

  readonly isOrganizationView = computed(() => this.viewMode() === ProgramOrganizationType.Organization);

  readonly sitePerformanceData = this.store.selectSignal(Selectors.selectSitePerformanceEvents);
  readonly productPerformanceData = this.store.selectSignal(Selectors.selectProductPerformanceEvents);
  readonly siteLoading = this.store.selectSignal(Selectors.selectSitePerformanceEventsLoading);
  readonly productLoading = this.store.selectSignal(Selectors.selectProductPerformanceEventsLoading);

  readonly siteLabelAccessor: (e: PerformanceEvent) => string = e => e.siteName || e.siteId;

  readonly productLabelAccessor = computed<(e: PerformanceEvent) => string>(() => {
    const productNameById = new Map<string, string>(this.products().map((p: Product) => [p.id, p.name]));
    return (e: PerformanceEvent) => productNameById.get(e.productId) || e.productId;
  });
}
